import { useCallback, useContext, useEffect, useState } from "react";
import { CalculationNature, CalculationTargetResourceType } from "services/common/CalculatorUtils";
import { getAccountAttributesByBondType, getAccountCategorizedAttributes } from "services/edge/AttributesService";
import { getAccountCalculations } from "services/edge/CalculatorService";
import { Context } from "states/Store";


const useAccountAttributes = () => {
    const [state] = useContext(Context);

    const [dossierAttributes, setDossierAttributes] = useState(null)
    const [thirdpartyAttributes, setThirdpartyAttributes] = useState(null)
    const [thirdpartyCalculatedAttributes, setThirdpartyCalculatedAttributes] = useState(null)
    const [thirdpartyIndicators, setThirdpartyIndicators] = useState(null)
    const [dossierCalculatedAttributes, setDossierCalculatedAttributes] = useState(null)
    const [dossierIndicators, setDossierIndicators] = useState(null)

   const mapCalculation = (calcul) => {
    return {
            value: calcul.id,
            label: calcul.name,
            type: calcul.resultType, 
            options: calcul?.branches?.map(branch => {
              return  {
                value: branch.resultValue,
                color: branch.resultColorCode
              }
              //filter identical branch resultValue
              }).reduce((acc, entry) => {
              if(acc.some((item) => item.value === entry.value && item.color === entry.color)) {
                return acc;
              } else {
                acc.push(entry);
                return acc;
              }
            }, [])
            
          }
   } 

  const manageAttributesOptions = (attribute) => {
    if(!attribute) return null;
    if(attribute.values) {
      return attribute?.values?.map(attValue => {
        return {
          value: attValue.value
        }
      })
    } else if(attribute.type === "boolean") {
      return [{value: "true", translation :"yes"}, {value: "false", translation :"no"}]
    }
    return null;
}

  // Fetch attributes
  const fetchAttributes = useCallback(async () => {
    try {
      const [thirdpartyResults, thirdpartyCategorizedResults, dossierResults, calculationResults] = await Promise.all([
        getAccountAttributesByBondType(state.account.id, "thirdparty", null),
        getAccountCategorizedAttributes(state.account.id, null, "thirdparty", null),
        getAccountAttributesByBondType(state.account.id, "dossier", null),
        getAccountCalculations(state.account.id, null, null)
      ]);

      let thirdpartyCalculatedAttributes = [];
      let thirdpartyIndicators = [];
      let dossierCalculatedAttributes = [];
      let dossierIndicators = [];

      calculationResults.content.filter(calcul => calcul.enabled).forEach(calcul => {
        if (calcul.nature === CalculationNature.INDICATOR && calcul.targetResourceType === CalculationTargetResourceType.THIRD_PARTY) {
          thirdpartyIndicators.push(mapCalculation(calcul));
        }
        if (calcul.nature === CalculationNature.INDICATOR && calcul.targetResourceType === CalculationTargetResourceType.DOSSIER) {
          dossierIndicators.push(mapCalculation(calcul));
        }
        if (calcul.nature === CalculationNature.CALCULATED_ATTRIBUTE && calcul.targetResourceType === CalculationTargetResourceType.THIRD_PARTY) {
          thirdpartyCalculatedAttributes.push(mapCalculation(calcul));
        }
        if (calcul.nature === CalculationNature.CALCULATED_ATTRIBUTE && calcul.targetResourceType === CalculationTargetResourceType.DOSSIER) {
          dossierCalculatedAttributes.push(mapCalculation(calcul));
        }
      })

      setThirdpartyCalculatedAttributes(thirdpartyCalculatedAttributes.sort((a, b) => a.label.localeCompare(b.label)));
      setThirdpartyIndicators(thirdpartyIndicators.sort((a, b) => a.label.localeCompare(b.label)));

      setDossierCalculatedAttributes(dossierCalculatedAttributes.sort((a, b) => a.label.localeCompare(b.label)));
      setDossierIndicators(dossierIndicators.sort((a, b) => a.label.localeCompare(b.label)));

      setDossierAttributes(dossierResults.content?.map(attribute => {
        return {
          ...attribute,
          options: manageAttributesOptions(attribute)
        }
      }).sort((a, b) => a.label.localeCompare(b.label)));

      const thirdpartyRawAttributes = [
        ...(thirdpartyResults?.content ?? []),
        ...(thirdpartyCategorizedResults?.content ?? [])
      ];

      setThirdpartyAttributes(thirdpartyRawAttributes.map(attribute => {
        return {
          ...attribute,
          options: manageAttributesOptions(attribute)
        }
      }).sort((a, b) => a.label.localeCompare(b.label)));

    } catch (error) {
      setDossierAttributes([]);
      setThirdpartyAttributes([]);
      setThirdpartyCalculatedAttributes([]);
      setThirdpartyIndicators([]);
      setDossierCalculatedAttributes([]);
      setDossierIndicators([]);
    }
  }, [state.account]);

  useEffect(() => {
    if (state.account) {
      fetchAttributes();
    }
  }, [state.account, fetchAttributes])


  return {
    accountAttributesAndIndicators: {
      thirdpartyAttributes: thirdpartyAttributes,
      dossierAttributes: dossierAttributes,
      thirdpartyCalculatedAttributes : thirdpartyCalculatedAttributes,
      dossierCalculatedAttributes : dossierCalculatedAttributes,
      thirdpartyIndicators : thirdpartyIndicators,
      dossierIndicators: dossierIndicators

    }
  }

}

export default useAccountAttributes;